import axios from 'axios';

import { ENV_VARIABLES } from '@/constants';
import { setupAuthInterceptors } from '@/libs';

const apiPanoramaV2 = axios.create({
  baseURL: ENV_VARIABLES.PANORAMA_V2_API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

setupAuthInterceptors(apiPanoramaV2);

export default apiPanoramaV2;
